skrilla.controller('pickemsCreateContestCtrl', function ($scope, searchService, queryService, paginationService, cacheService, srefService, envService) {


    $scope.positionNames = ['1st','2nd', '3rd', '4th', '5th']

    $scope.newContest = {
        title: "",
        description: "",
        cardImageUri: "",
        rules: "",
        prizePool: [10,5,1,0,0]
    };

    $scope.save = function() {
        const prizePool = $scope.newContest.prizePool.map(function (p) { return p * 100});
        const newContest = {...$scope.newContest, prizePool: prizePool}
        searchService.post('pickems/contests/', newContest, "Contest Created").then( function(response) {
            srefService.go("pickemsContestDetails", {id: response.data.id});
        });
    }

  $scope.$watch(
    "newContest.cardImageUri",
    ( newValue, oldValue ) => {
      $scope.setThumb();

    }
  );
  $scope.setThumb = function() {
    const cardImageUri = $scope.newContest ? $scope.newContest.cardImageUri : "";
    if (cardImageUri.startsWith("https://res.cloudinary")) {
      $scope.thumbnail = cardImageUri.replace("/upload", "/upload/c_scale,h_150")
    } else {
      $scope.thumbnail = cardImageUri
    }
  }
  //Pre load the widget so user doesn't have to wait
  $scope.mediaLibraryWidget = cloudinary.createMediaLibrary({
        ...envService.read('cloudinary'),
        multiple: false,
        max_files: 1
    }, {
        insertHandler: function (data) {
          data.assets.forEach(asset => {
            $scope.$apply(() => {
              if (asset.derived && asset.derived.length > 0) {
                $scope.newContest.cardImageUri = asset.derived[0].secure_url;
              } else {
                $scope.newContest.cardImageUri = asset.secure_url;
              }
            })
          })
        }
      }
    );

  $scope.openLibraryWidget = function() {
      $scope.mediaLibraryWidget.show({
        folder: {path: "pickems", resource_type: "image"},
      });
    }

    $scope.loadExchangeRates = function(){
          searchService.get('pickems/exchangeRates/USD', {}).then( function(response) {
              $scope.newContest.exchangeRates = response.data;
          });
    }

});
